import React from "react";
import CustomRow from "../../shared/costum-row/costum-row";
import { Col, Typography } from "antd";

import "./styles.scss";

const { Title, Text } = Typography;

interface BlogParagraphProps {
  content?: string;
  title?: string;
}

const BlogParagraph: React.FC<BlogParagraphProps> = ({ 
  content = "In den USA ist es landesweit zu Protesten gegen Massenentlassungen in den Behörden durch den Unternehmer und Regierungsbeauftragten Elon Musk gekommen. Hunderte Menschen demonstrierten vor Tesla-Geschäften in Florida, Arizona oder New York. Demonstranten blockierten den Verkehr und schwenkten Transparente mit Aufschriften wie \"Verbrennt einen Tesla: Rettet die Demokratie\" und \"Keine Diktatoren in den USA\". Bei der Demonstration vor einem Tesla-Autohaus in New York wurden dabei laut Polizei neun Menschen festgenommen.\n\nDie Proteste richteten sich gegen Tesla-Chef Musk, der als Sonderbeauftragter in der neuen sogenannten Behörde für Regierungseffizienz (DOGE) unter US-Präsident Donald Trump umfangreiche Kürzungen im Bundesdienst anordnete. Die Organisatoren der landesweiten Protestaktion \"Tesla Takedown\" riefen auch dazu auf, Tesla-Aktien zu verkaufen.",
  title = "Lorem ipsum dolor sit"
}) => {
  return (
    <CustomRow justify={"space-between"} gutter={[0, 25]}>
      <Col span={24}>
        <Title className="BlogParagraph-title">{title}</Title>
      </Col>
      <Col span={24}>
        <Text className="BlogParagraph-text">
          {content.split('\n').map((paragraph, index) => (
            <React.Fragment key={index}>
              {paragraph}
              {index < content.split('\n').length - 1 && (
                <>
                  <br />
                  <br />
                </>
              )}
            </React.Fragment>
          ))}
        </Text>
      </Col>
    </CustomRow>
  );
};

export default BlogParagraph;
